import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import FormActionResponsiveButtons from 'components/FormActionButtons/FormActionResponsiveButtons';
import { GenericTitle, TitleMargin } from 'components/GenericTitle/GenericTitle';
import GenericTitleSummary from 'components/GenericTitleSummary/GenericTitleSummary';
import { GenericTooltip, TooltipPlacement } from 'components/GenericTooltip';

import { Fields, StepProps } from '../../types';
import YesNoButtons from '../shared/YesNoButtons';

const StepCashReserves: FC<StepProps> = ({ values }) => (
  <>
    <GenericTitle marginBottom={TitleMargin.Sm} isMedium isBlock>
      <FormattedMessage id="onboarding.stepCashReserve.title" tagName="span" />
      <GenericTooltip
        text={<FormattedMessage id="onboarding.stepCashReserve.titleTooltip" />}
        position={TooltipPlacement.Bottom}
        hasNoMargin
      />
    </GenericTitle>

    <GenericTitleSummary hasMarginBottomLg>
      <FormattedMessage id="onboarding.stepCashReserve.summary" />
    </GenericTitleSummary>

    <YesNoButtons name={Fields.CashReserve} />

    <FormActionResponsiveButtons
      submitDisabled={values[Fields.CashReserve] === undefined}
      hasUnderline
    />
  </>
);

export default StepCashReserves;
